/**
 * Ladezustand der Dokumentliste in Zielform (Spec 35, AK-1114): eine
 * Monatsüberschrift, darunter Zeilen mit Symbolkachel und Textzeilen — bei
 * 380 px dreizeilig wie die Karte (Titel, „Art · Absender“, „Objekt · Datum“),
 * am Schreibtisch zweizeilig wie die Tabellenzeile. Zeilenhöhe = Höhe der
 * echten Zeile (`DocumentListBody.bild.test.tsx`), damit beim Eintreffen
 * nichts springt. Bezeichner `document-list-loading` bleibt wie bisher.
 */

const SKELETON_ROWS = 6

/** Eine Textzeile in der Höhe der echten Zeile (`h-5` = Titel, `h-4` = Label). */
function Line({ className, width }: { className: string; width: string }) {
  return (
    <div className={`flex items-center ${className}`}>
      <div className={`bg-border h-2 w-full animate-pulse rounded-full ${width}`} />
    </div>
  )
}

export function DocumentListSkeletonRow() {
  return (
    <div
      data-testid="document-list-loading-row"
      className="border-border flex items-start gap-3 border-b px-(--page-x) py-2 md:h-(--row-h) md:items-center md:py-0"
    >
      <div className="bg-border size-7 shrink-0 animate-pulse rounded-(--radius-card)" />
      <div className="flex min-w-0 flex-1 flex-col gap-1 md:gap-0">
        <Line className="h-5" width="max-w-64" />
        <Line className="h-4" width="max-w-40" />
        <Line className="h-4 md:hidden" width="max-w-48" />
      </div>
    </div>
  )
}

export function DocumentListSkeleton() {
  return (
    <div data-testid="document-list-loading" aria-busy="true" aria-live="polite" className="flex flex-col">
      <span className="sr-only">Wird geladen</span>
      {/* `p` statt `div`: AK-522 zählt die direkten `div`-Kinder als Zeilen. */}
      <p className="px-(--page-x) pt-4 pb-1">
        <span className="bg-border block h-2 w-24 animate-pulse rounded-full" />
      </p>
      {Array.from({ length: SKELETON_ROWS }, (_, index) => (
        <DocumentListSkeletonRow key={index} />
      ))}
    </div>
  )
}
